var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _g, _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "256px",
    height: "256px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "33.78,8.995 19.872,12.482 9.76,22.502 25.768,22.502"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "9.793,25.503 19.873,35.446 33.82,38.933 25.804,25.503"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "36.433,10.528 28.447,24.001 36.433,37.434 40.294,24.001"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    points: "20.126,12.934 32.738,9.771 25.483,22.002 10.975,22.002",
    opacity: 0.07
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 2,
    points: "20.126,12.934 32.738,9.771 25.483,22.002 10.975,22.002",
    opacity: 0.05
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    points: "20.126,12.934 32.738,9.771 25.483,22.002 10.975,22.002",
    opacity: 0.07
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    points: "36.272,36.185 29.029,24.001 36.272,11.78 39.774,24.001",
    opacity: 0.07
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    points: "20.126,34.994 11.012,26.003 25.52,26.003 32.775,38.156",
    opacity: 0.07
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 2,
    points: "36.272,36.185 29.029,24.001 36.272,11.78 39.774,24.001",
    opacity: 0.05
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    points: "36.272,36.185 29.029,24.001 36.272,11.78 39.774,24.001",
    opacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1d1d1b",
    strokeWidth: 2,
    points: "20.126,34.994 11.012,26.003 25.52,26.003 32.775,38.156",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#000",
    points: "20.126,34.994 11.012,26.003 25.52,26.003 32.775,38.156",
    opacity: 0.07
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "_SHrDBwHedFQ~y1bkV39Ka",
    x1: 16.008,
    x2: 39.945,
    y1: 6.199,
    y2: 45.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#_SHrDBwHedFQ~y1bkV39Ka)",
    d: "M36.272,36.185l-7.243-12.184l7.243-12.221l3.502,12.221L36.272,36.185z M20.126,34.994 l-9.115-8.991H25.52l7.254,12.153L20.126,34.994z M20.126,12.934l12.611-3.162l-7.254,12.231H10.975L20.126,12.934z M37.687,4.033 L22.579,7.955c-0.26,0.068-0.483,0.236-0.619,0.469l-2.243,3.841l-4.533-0.034c-0.266-0.002-0.521,0.101-0.712,0.286L3.39,23.275 c-0.409,0.398-0.409,1.055,0.001,1.452l11.081,10.724c0.19,0.184,0.446,0.286,0.711,0.284l4.534-0.034l2.244,3.842 c0.135,0.232,0.357,0.4,0.617,0.468l15.108,3.956c0.536,0.14,1.085-0.177,1.231-0.711l4.047-14.789 c0.074-0.269,0.033-0.557-0.113-0.795l-2.249-3.667l2.249-3.674c0.146-0.238,0.187-0.526,0.113-0.795L38.916,4.744 C38.77,4.211,38.222,3.894,37.687,4.033z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/Unity.854168496d0141d705d2110aa9dd41b4.svg";
export { ForwardRef as ReactComponent };